// @flow
import React from "react";
import { GlobalProvider } from "../common/GlobalContext";
import type { $Site } from "flow/types";

import Elevate from "./Elevate";
import Agentology from "./Agentology";

type $Props = {
  theme: Object,
  tenant: string,
  site: $Site,
};

const Terms = ({ theme, tenant, site }: $Props) => (
  <GlobalProvider theme={theme} site={site}>
    {tenant === "agentology" ? <Agentology /> : <Elevate />}
  </GlobalProvider>
);

export default Terms;
